import React, { useMemo } from 'react';
import { useAITTheme, type AITTheme } from '@this/shared/ui/theme';
import type { GoogleReviews } from '../../../types/proposalItemGoogleReviews';

interface Props {
  googleReviews: GoogleReviews;
}

const GoogleReviewsSection = ({ googleReviews }: Props) => {
  const { theme } = useAITTheme();
  const styles = useMemo(() => getStyles(theme), [theme]);

  if (googleReviews.reviews.length === 0) return null;

  return (
    <div style={styles.reviewsSection}>
      <div style={styles.sectionTitle}>
        クチコミ
        {googleReviews.rating != null && (
          <span style={styles.googleRating}>Google評価：★{googleReviews.rating.toFixed(1)}</span>
        )}
      </div>
      <div style={styles.reviewsBox}>
        {googleReviews.reviews.map((review, index) => (
          <div
            key={`${review.authorName}_${review.relativeTimeDescription}_${review.text}`}
            style={{
              ...styles.reviewItem,
              ...(index === googleReviews.reviews.length - 1 ? styles.reviewItemLast : {})
            }}
          >
            <div style={styles.reviewHeader}>
              <span style={styles.reviewStars}>
                {'★'.repeat(review.rating)}
                {'☆'.repeat(5 - review.rating)}
              </span>
              <span style={styles.reviewAuthor}>{review.authorName}</span>
              <span style={styles.reviewTime}>{review.relativeTimeDescription}</span>
            </div>
            <div style={styles.reviewText}>{review.text}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

const getStyles = (theme: AITTheme) => ({
  reviewsSection: {
    marginTop: '16px'
  },
  sectionTitle: {
    fontSize: '12px',
    fontWeight: 600 as const,
    marginBottom: '4px',
    color: theme.grayTextColor
  },
  googleRating: {
    marginLeft: '8px',
    fontSize: '13px',
    fontWeight: 400 as const,
    color: theme.textColor
  },
  reviewsBox: {
    backgroundColor: '#f5f5f5',
    padding: '8px 12px',
    borderRadius: '8px'
  },
  reviewItem: {
    borderBottom: '1px solid #e0e0e0',
    padding: '10px 0'
  },
  reviewItemLast: {
    borderBottom: 'none'
  },
  reviewHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    marginBottom: '4px',
    fontSize: '12px'
  },
  reviewStars: {
    color: '#f5a623',
    fontSize: '13px',
    whiteSpace: 'nowrap' as const
  },
  reviewAuthor: {
    fontWeight: 700 as const,
    color: theme.textColor
  },
  reviewTime: {
    color: '#999999'
  },
  reviewText: {
    fontSize: '12px',
    lineHeight: 1.6,
    whiteSpace: 'pre-wrap' as const,
    color: theme.textColor
  }
});

export default GoogleReviewsSection;
